import { postRequest } from "../libs/AxiosService.util";


export async function serviceGetVendorsRecommendationApproval(params) {
    return await postRequest('recommended/vendors', params);
}

export async function serviceGetVendorsRecommendationApprovalDetail(params) {
    return await postRequest('recommended/vendors/detail', params);
}

export async function serviceApproveRecommendationRequst(params) {
    return await postRequest('recommended/vendors/approve', params);
}

export async function serviceRejectRecommendationRequst(params) {
    return await postRequest('recommended/vendors/reject', params);
}